"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDeliveryItem = useDeliveryItem;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _models = require("../../models");
var _utils = require("../../utils");
function useDeliveryItem(props) {
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { activeCourier, activeFilter, boxName, deliveryItem, isActive, isButtonConfirmationEnabled, isDisplayedInMainPage = false, isRefreshPending = false, isSelectedDeliveryLoading = false, isShownOnMap, metaHierarchy, onDeleteAddressClick, onDeliveryItemActivation, onEditAddressClick, onShippingOfferBannerClick, setActiveCourier, setIsDeliveryChanged, setIsRefreshPending, setSelectedDeliveryChannelId } = props;
    const { addressId, courierLogo, courierName, deliveryChannelId, deliveryFee, deliveryMethod, estimatedDelivery, hintMessages = [], deliveryComment, isAddressDeletable, isAddressEditable, isAllowed, isCommentEnabled, isPrimaryAddress, isShippingJoker, telephoneNumber, workingHours } = deliveryItem;
    const isInvalid = !isAllowed;
    const isHomeDelivery = deliveryMethod === _models.AddressItemDeliveryMethod.Home;
    const isAdditionalInfoVisible = Boolean(isDisplayedInMainPage && (Boolean(telephoneNumber) || Boolean(isCommentEnabled) || Boolean(deliveryComment)) || deliveryMethod !== _models.AddressItemDeliveryMethod.Home && workingHours);
    const isPickupShippingOfferVisible = !isHomeDelivery && isDisplayedInMainPage && isShippingJoker;
    const isCourierSelection = isHomeDelivery && addressId !== undefined && activeCourier !== undefined;
    const isBoundCourierVisible = !isDisplayedInMainPage && isHomeDelivery && activeFilter === _models.DeliveryOptionsFilter.History;
    const isFilteredHomeAddress = activeFilter === _models.DeliveryOptionsFilter.AllAddresses || activeFilter === _models.DeliveryOptionsFilter.MyAddresses || activeFilter === _models.DeliveryOptionsFilter.MyFriends;
    const courier = (0, _react.useMemo)(()=>{
        const deliveryItemCourier = {
            deliveryChannelId,
            deliveryFee,
            estimatedDelivery,
            image: courierLogo !== null && courierLogo !== void 0 ? courierLogo : null,
            isShippingJoker,
            name: courierName !== null && courierName !== void 0 ? courierName : '',
            priority: 0 // no effect
        };
        return deliveryItemCourier;
    }, [
        courierLogo,
        courierName,
        deliveryChannelId,
        deliveryFee,
        estimatedDelivery,
        isShippingJoker
    ]);
    const activateDeliveryItem = (0, _react.useCallback)(()=>{
        if (isDisplayedInMainPage || isInvalid) {
            // TO-DO: Maybe we would like to log the user's intention to analytics even here?
            return;
        }
        // analytics - final item selection & closing delivery options dialog
        (0, _utils.dispatchUserActionEvent)([
            ...metaHierarchy,
            _models.MetaHierarchy.SelectResult
        ]);
        onDeliveryItemActivation === null || onDeliveryItemActivation === void 0 ? void 0 : onDeliveryItemActivation(deliveryItem);
    }, [
        deliveryItem,
        isInvalid,
        isDisplayedInMainPage,
        metaHierarchy,
        onDeliveryItemActivation
    ]);
    const handleDeliveryBoxClick = (0, _react.useCallback)((event)=>{
        if (isButtonConfirmationEnabled) {
            if (!isActive) {
                // analytics - item pre-selection with displaying the confirm button
                (0, _utils.dispatchUserActionEvent)([
                    ...metaHierarchy,
                    _models.MetaHierarchy.SelectNearby
                ]);
            }
            setSelectedDeliveryChannelId === null || setSelectedDeliveryChannelId === void 0 ? void 0 : setSelectedDeliveryChannelId(deliveryChannelId);
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        activateDeliveryItem();
    }, [
        activateDeliveryItem,
        deliveryChannelId,
        isActive,
        isButtonConfirmationEnabled,
        metaHierarchy,
        setSelectedDeliveryChannelId
    ]);
    const addressAndCourierWrapperProps = {
        onClick: handleDeliveryBoxClick,
        ...getTestIdProps(_models.TestId.DeliveryBoxLabel)
    };
    const addressWrapperProps = {
        ...deliveryItem,
        onDeleteAddressClick: isDisplayedInMainPage ? undefined : onDeleteAddressClick,
        onEditAddressClick: isDisplayedInMainPage ? undefined : onEditAddressClick,
        onShippingOfferBannerClick: isDisplayedInMainPage ? undefined : onShippingOfferBannerClick,
        isAddressEditable: isDisplayedInMainPage ? false : isAddressEditable,
        isBoundCourierVisible,
        isDisplayedInMainPage
    };
    const courierSelectionProps = {
        activeCourier: activeCourier !== null && activeCourier !== void 0 ? activeCourier : 0,
        currentAddressId: addressId !== null && addressId !== void 0 ? addressId : 0,
        hintMessages,
        isRefreshPending,
        isSelectedDeliveryLoading,
        setActiveCourier,
        setIsDeliveryChanged,
        setIsRefreshPending,
        onShippingOfferBannerClick
    };
    const ownerState = {
        isActive,
        isFilteredHomeAddress,
        isInvalid,
        isDisplayedInMainPage,
        isShownOnMap
    };
    const testId = "".concat(boxName, "-").concat(_models.TestId.DeliveryBox, "-").concat(addressId);
    return {
        ...props,
        activateDeliveryItem,
        addressAndCourierWrapperProps,
        addressId,
        addressWrapperProps,
        courier,
        courierName,
        courierSelectionProps,
        hintMessages,
        isAdditionalInfoVisible,
        isAddressDeletable,
        isAddressEditable,
        isBoundCourierVisible,
        isCourierSelection,
        isFilteredHomeAddress,
        isHomeDelivery,
        isInvalid,
        isPickupShippingOfferVisible,
        isPrimaryAddress,
        ownerState,
        testId
    };
}
